import React from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineShieldCheck, HiOutlineDocumentText, HiOutlineEnvelope } from 'react-icons/hi2';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        {/* Newsletter Section */}
        <div className="footer-newsletter">
          <div className="newsletter-content">
            <h3>Teknoloji Bültenimize Abone Olun</h3>
            <p>Yeni çözümler, güncellemeler ve sektörel gelişmelerden haberdar olun.</p>
          </div>
          <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
            <input type="email" placeholder="E-posta adresiniz" />
            <button type="submit" className="btn btn-primary">Abone Ol</button>
          </form>
        </div>

        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="logo">
              <div className="logo-icon">E</div>
              <div className="logo-text">
                <span className="brand">EMUR <span>INNOVATION</span></span>
                <span className="tagline">Cloud Solutions</span>
              </div>
            </Link>
            <p>
              EMUR INNOVATION, İstanbul, Ankara ve İzmir'de hizmet veren yeni nesil bulut teknoloji firmasıdır.
              KVKK uyumlu, güvenli altyapı çözümleri sunuyoruz.
            </p>

            {/* Contact Info */}
            <div className="footer-contact-info">
              <div className="footer-contact-item">
                <HiOutlineEnvelope size={16} />
                <a href="mailto:info@emurinnovation.com">info@emurinnovation.com</a>
              </div>
            </div>

            {/* Social Media */}
            <div className="footer-social">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="X">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
              </a>
            </div>
          </div>

          <div className="footer-column">
            <h4>Çözümler</h4>
            <div className="footer-links">
              <Link to="/cozumler/guvenlik">Siber Güvenlik</Link>
              <Link to="/cozumler/network">Network Çözümleri</Link>
              <Link to="/cozumler/veri-merkezi">Veri Merkezi</Link>
              <Link to="/cozumler/yedekleme">Yedekleme & Arşivleme</Link>
              <Link to="/cozumler/mail">Mail Çözümleri</Link>
              <Link to="/cozumler/startup">Startup Çözümleri</Link>
              <Link to="/cozumler/gelistirme-test">Geliştirme & Test</Link>
              <Link to="/cozumler/kvkk">KVKK Danışmanlığı</Link>
            </div>
          </div>

          <div className="footer-column">
            <h4>Hizmetler</h4>
            <div className="footer-links">
              <Link to="/hizmetler/bulut">Bulut Hizmetleri</Link>
              <Link to="/hizmetler/dijital-donusum">Dijital Dönüşüm</Link>
              <Link to="/hizmetler/emurone">EmurOne</Link>
              <Link to="/hizmetler/hpc">HPC</Link>
              <Link to="/hizmetler/ozel-bulut">Özel Bulut Sunucu</Link>
              <Link to="/hizmetler/danismanlik">Danışmanlık</Link>
              <Link to="/hizmetler/felaket-kurtarma">Felaket Kurtarma</Link>
              <Link to="/hizmetler/monitoring">Monitoring</Link>
            </div>
          </div>

          <div className="footer-column">
            <h4>Kurumsal</h4>
            <div className="footer-links">
              <Link to="/hakkimizda">Hakkımızda</Link>
              <Link to="/neden-emur">Neden EMUR</Link>
              <Link to="/is-ortaklarimiz">İş Ortaklarımız</Link>
              <Link to="/referanslarimiz">Referanslarımız</Link>
              <Link to="/basari-hikayeleri">Başarı Hikayeleri</Link>
              <Link to="/insan-kaynaklari">İnsan Kaynakları</Link>
              <Link to="/iletisim">İletişim</Link>
              <Link to="/destek">Destek Merkezi</Link>
            </div>
          </div>
        </div>

        {/* Certifications */}
        <div className="footer-certs">
          <div className="footer-cert-item">
            <HiOutlineShieldCheck size={22} />
            <span>ISO 27001 Sertifikalı</span>
          </div>
          <div className="footer-cert-item">
            <HiOutlineDocumentText size={22} />
            <span>KVKK Uyumlu</span>
          </div>
          <div className="footer-cert-item">
            <HiOutlineShieldCheck size={22} />
            <span>Tier 3+ Veri Merkezi</span>
          </div>
          <div className="footer-cert-item">
            <HiOutlineShieldCheck size={22} />
            <span>SOC 2 Type II</span>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 EMUR INNOVATION Teknoloji Bilişim Çözümleri A.Ş. Tüm hakları saklıdır.</p>
          <div className="footer-bottom-links">
            <Link to="/gizlilik">Gizlilik Sözleşmesi</Link>
            <Link to="/hizmet-sozlesmesi">Hizmet Sözleşmesi</Link>
            <Link to="/kvk-aydinlatma">KVK Aydınlatma Metni</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
